<script lang="ts">import { showOnlyUnread, showPersonalNotifications } from "../state";
import { FeatureSet, stateFeatureSet, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Tabs } from "@infinitro/tabs";
import { Text } from "@infinitro/text";
import { get } from "svelte/store";
let activeTab = $state(get(showPersonalNotifications) ? "personal" : "platform");
let tabs = $derived([{
	label: $t(Verbiage.personal),
	value: "personal",
	id: "personalTab"
}, {
	label: $t(Verbiage.platform),
	value: "platform",
	id: "platformTab"
}]);
let useTransparentTabs = $derived(Boolean($stateUi.notifications?.useTransparentTabs ?? false));
let useFlatNeutral = $derived(Boolean($stateUi.notifications?.useFlatNeutralPanel ?? false));
const selectTab = (tab) => {
	activeTab = tab;
	showPersonalNotifications.set(tab === "personal");
};
</script>

<InfoCard
	width="100%"
	height={$stateFeatureSet === FeatureSet.Preview ? '140px' : '50px'}
	withoutBorder
	customStylesCard={useFlatNeutral
		? 'background: var(--color-background-500); border: 1px solid var(--color-neutral-900);'
		: 'background-image: var(--gradient-alternative-2), linear-gradient(to top, rgba(24, 31, 69, 1) 0%, rgba(24, 31, 69, 1) 58%, rgba(255, 255, 255, 0.22) 100%);'}
>
	<div class="notifications-header">
		<div class="d-flex">
			<Text>
				{$t(Verbiage.notifications)}
			</Text>
		</div>
		{#if $stateFeatureSet === FeatureSet.Preview}
			<div class="all-or-unread">
				<small class="all-or-unread-text">{$t(Verbiage.all)}</small>
				<label class="switch">
					<input
						type="checkbox"
						checked={$showOnlyUnread}
						onchange={(e) => showOnlyUnread.set(e.currentTarget.checked)}
					/>
					<span class="slider"></span>
				</label>
				<small class="all-or-unread-text">{$t(Verbiage.unread)}</small>
			</div>

			<div class="tabs-container">
				<Tabs
					bind:activeTab
					{tabs}
					onChange={(detail) => selectTab(detail.value as 'platform' | 'personal')}
					size="large"
					transparentBackground={useTransparentTabs}
				/>
			</div>
		{/if}
	</div>
</InfoCard>

<style>
	:global(#platformTab, #personalTab) {
		max-width: 48%;
	}

	:global(#platformTab p, #personalTab p) {
		font-size: clamp(8px, 1vw, 11px);
	}

	.notifications-header {
		display: flex;
		height: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
}

	.d-flex {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		gap: 1rem;
}

	/*
    .close-button {
     @apply cursor-pointer bg-transparent border-none outline-none;
    }
    */
	.switch {
		position: relative;
		display: inline-block;
		height: 16px;
		width: 28px;
		-webkit-user-select: none;
		   -moz-user-select: none;
		        user-select: none;
		vertical-align: middle;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-duration: 200ms;
		transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

	.switch input {
		position: absolute;
		height: 0px;
		width: 0px;
		opacity: 0;
}

	.slider {
		display: block;
		height: 16px;
		cursor: pointer;
		overflow: hidden;
		border-radius: 9999px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: transparent;
}

	.slider:before {
		position: absolute;
		left: 2px;
		top: 2px;
		display: block;
		height: 12px;
		width: 12px;
		border-radius: 9999px;
		background-color: var(--color-neutral-900);
		--tw-shadow-color: var(--shadow-neutral);
		--tw-shadow: var(--tw-shadow-colored);
		content: '';
		transition:
			transform 0.3s,
			background-color 0.3s;
}

	input:checked + .slider {
		border-color: var(--color-primary-500);
}

	input:checked + .slider:before {
		background-color: var(--color-primary-500);
		transform: translateX(12px);
		background-image: none;
}

	.all-or-unread {
		display: flex;
		width: 100%;
		align-items: center;
		gap: 0.5rem;
}

	.tabs-container {
		margin-bottom: 0.5rem;
		width: 100%;
}
</style>
